import { Component, inject } from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  MatCard,
  MatCardImage,
  MatCardHeader,
  MatCardTitle,
  MatCardSubtitle,
  MatCardContent,
  MatCardAvatar,
  MatCardActions,
} from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import {
  MatChipListbox,
  MatChipOption,
  MatChipAvatar,
} from '@angular/material/chips';
import { MatTooltip } from '@angular/material/tooltip';
import { EditMenuComponent } from 'edit-menu';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ConfirmDialogComponent } from '@dges/ui/confirm-dialog';
import { map } from 'rxjs/operators';
import {
  CAN_ADD,
  CAN_DELETE,
  CAN_EDIT,
  ENTITY_FACADE,
  ENTITY_FORM_COMPONENT,
  ENTITY_TO_CARD_MAPPER,
  EntityCard,
} from '../entity-list.tokens';

@Component({
  selector: 'lib-entity-list',
  templateUrl: './entity-list.component.html',
  standalone: true,
  host: {
    class: 'flex flex-wrap justify-center',
  },
  imports: [
    AsyncPipe,
    MatProgressSpinner,
    MatCard,
    MatCardAvatar,
    MatCardImage,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatCardContent,
    MatCardActions,
    MatChipListbox,
    MatChipOption,
    MatChipAvatar,
    MatTooltip,
    NgOptimizedImage,
    EditMenuComponent,
    MatFabButton,
    MatIcon,
  ],
})
export class EntityListComponent {
  facade = inject(ENTITY_FACADE);
  canAdd = inject(CAN_ADD, { optional: true }) ?? false;
  canEdit = inject(CAN_EDIT, { optional: true }) ?? false;
  canDelete = inject(CAN_DELETE, { optional: true }) ?? false;
  private formComponent = inject(ENTITY_FORM_COMPONENT, { optional: true });
  private toCard = inject(ENTITY_TO_CARD_MAPPER);
  private dialog = inject(MatDialog);

  readonly cards$ = this.facade.allEntities$.pipe(
    map((entities) => entities.map(this.toCard)),
  );

  constructor() {
    this.facade.load();
  }

  onAdd(): void {
    if (this.formComponent) {
      this.dialog.open(this.formComponent);
    }
  }

  onEdit(card: EntityCard): void {
    if (this.formComponent) {
      this.dialog.open(this.formComponent, {
        data: card.raw,
      });
    }
  }

  onDelete(card: EntityCard): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: `Are you sure you want to delete ${card.title}`,
    });
    dialogRef.afterClosed().subscribe((approved) => {
      if (approved) {
        this.facade.deleteEntity(card.raw);
      }
    });
  }
}
